<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="8" viewBox="0 0 7 8" fill="none" :class="color">
        <path d="M-3.33786e-06 7.44943e-08L-3.24246e-06 8L6.90909 4" fill="#666666"/>
    </svg>
</template>

<script>
    export default {
        name: 'accordion-open',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
